import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'
import auth from '../../utils/auth';
import request from '../../utils/request';
import { makeStyles,useTheme } from '@material-ui/styles';

import MainTab from './MainTab.js';
import ClubTab from './ClubTab.js';

//import PelotonTab from '../Workout/index.js';

import {
	AppBar,
  Box,
  Button,
  FormGroup,
  Menu,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
//    padding: theme.spacing(2)
  },
  topBar:{
		paddingBottom: '8px',
		borderBottom: '1px #dddddd solid',
	},
	whiteLine: {
		borderBottom: '1px #ffffff solid',
		marginBottom:'16px',	
	},
	title: {
		fontSize:'14px',		 
		color:'#73838b', fontWeight:'500',
		padding:'0px',
		[theme.breakpoints.up("md")]: {
			fontSize:'16px',
		},
	},
}));

const Peloton = () => {
  const classes = useStyles();

  const [pelotonId, setPelotonId] = React.useState(0);

  //다국어적용
  const { t }  = useTranslation(['page']);

  //const [popoverOpenInvite, setPopoverOpenInvite] = React.useState(false);
  useEffect(() => {
  }, []);

  function TabSelect(props) {
    if(pelotonId > 0) {
      return (
        <ClubTab pelotonId={pelotonId} />
      );
    } else {
      return (
        <MainTab />
      );
    }
  }


  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMovePeloton = (id) => {
    setPelotonId(id);
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
			<Box className={classes.topBar}>
				<Typography variant="h3" className={classes.title}>
					Peloton
					<Box style={{float:'right', height:'20px', display:'inline', margin:'-3px 0 20px 10px'}}>
          <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
            메인그룹
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={() => handleMovePeloton(0)}>메인그룹</MenuItem>
            <MenuItem onClick={() => handleMovePeloton(1)}>나의펠로톤1</MenuItem>
            <MenuItem onClick={() => handleMovePeloton(2)}>나의펠로톤2</MenuItem>
            <MenuItem onClick={() => handleMovePeloton(3)}>나의펠로톤3</MenuItem>
          </Menu>          
        </Box>
				</Typography>
			</Box>	
      <div className={classes.whiteLine}></div>
      <TabSelect />
    </div>
  );
};

Peloton.propTypes = {
  history: PropTypes.object
};

export default withRouter(Peloton);
